import React from 'react'

const CustomerPrivacyPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Customer Privacy Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <strong>Effective Date:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}05 March 2026</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Redqubes is a company incorporated under the laws of India, with its registered office at Jaipur, Rajasthan, and acts as the data controller for the purposes of applicable data protection laws. This Privacy Policy describes how Maidly collects, uses, shares, and protects user information when you use the Maidly mobile application and related services.
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Our Privacy Philosophy</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we recognize that your home is more than just a physical location; it is your private sanctuary. When you use our platform to hire a cook, a maid, or a plumber, you are placing an extraordinary amount of trust in us. We don't take that lightly. Our approach to privacy is built on four core pillars:
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Privacy by Design, Not by Afterthought:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}We don't build features and then try to "fix" the privacy later. Every button, tracking feature, and data field in this app is built with the assumption that your data belongs to you. If a piece of information doesn't directly help in getting your sink fixed or your house cleaned, we simply don't ask for it.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Human-Centric" Bridge:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}Unlike social media apps that want your data to sell ads, we only use your data to facilitate a human connection. We act as a professional filter. We ensure that while a worker has enough info to reach your doorstep and complete their job, they never have access to your private digital life or long-term personal history.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Radical Transparency:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}We believe you should never be surprised by how your data is used. Whether it’s the GPS ping that tells you your plumber is 5 minutes away or the notification that your cook has started their shift, we make sure you understand what is being tracked and why it’s happening in real-time.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Empowerment through Control:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}We believe that "Data Privacy" means "User Control." You are the boss of your information. You decide which landmarks to share, whether to allow background location, and when to wipe your history. We provide the tools; you provide the permissions.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Safety as a Shared Value:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}In the domestic service industry, privacy and safety are two sides of the same coin. We collect specific data—like verified identity and service ratings—to create a "Circle of Trust." By protecting the privacy of the customer and the dignity of the worker, we create a professional environment where everyone feels secure.
                                    </span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Comprehensive Data Collection</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We collect information through three main channels:</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>A. Information You Provide Directly:</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Profile Data:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Full name, profile photo, and gender (to help workers identify the correct household).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Home Coordinates:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Detailed address, including landmarks, floor numbers, and "Special Instructions”.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Preferences:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your preferred cleaning supplies, dietary restrictions for cooks, or specific plumbing brands you use.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>B. Automated Technical Data:</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Geo-Location:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}We track your location while the app is open to suggest the nearest available professionals and to calculate travel time for the worker. Location data is collected only while the app is in use and is required for core features such as assigning nearby service professionals and calculating estimated arrival times. Maidly requests access to your device location only while using the app to assign nearby service professionals and calculate arrival times. Background location tracking is optional. You will be asked to grant or deny this access when first using the app, and you can change these permissions anytime in your device settings. Users can manage or revoke app permissions such as location, notifications, and device access at any time through their device settings.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Device Metadata:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}IP address, browser type, device OS, and unique device identifiers to prevent fraudulent account creation.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>C. Communication Data:</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Chat:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We record chats between you and the service provider to ensure quality control and to provide evidence in case of a dispute or safety concern.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Purpose of Processing</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We process your information under several "Legal Bases," primarily to fulfill our contract with you, to ensure the safety of our community, and to improve your experience.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>A. Core Service Fulfillment</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Precision Matching:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We process your service requirements and your location to filter and display only the most relevant and available professionals in your immediate vicinity.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Digital Handshake":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We facilitate the connection by sharing your name and service address with the Professional only after you confirm a booking. This is strictly to allow the worker to reach your home and perform the task.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Real-Time Logistics:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We process GPS data from both you and the worker to provide accurate Estimated Time of Arrival and to notify you exactly when the professional has "Checked-In" or "Checked-Out" of your home.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>B. Trust, Safety, and Verification</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Identity Authentication:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use your phone number and OTP systems to ensure that every account belongs to a real person, preventing "bot" bookings and fraudulent activity.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Conflict Resolution:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We retain logs of in-app chats and service history. In the rare event of a dispute, damage claim, or safety incident, these logs are used by our Support Team to conduct a fair and evidence-based investigation.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service Quality Audits:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We process your ratings and reviews to maintain the high standard of the platform. If a professional consistently receives low scores for a specific data-driven reason, your feedback helps us take corrective action.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>C. Financial Transparency</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Standardized Billing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We process transaction data to generate digital invoices, ensuring you are charged the correct "Maidly" standard rate without the need for uncomfortable price haggling.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Secure Payment Flow:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we don't store your credit card numbers, we process "Tokens" provided by our payment partners to confirm that a payment was successful before a worker starts their journey.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>D. Personalized Experience &amp; Communication</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Predictive Scheduling:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you book a plumber every 6 months or a deep-cleaner every month, our system processes this "Usage Pattern" to send you helpful reminders, ensuring your home maintenance stays on track.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Lifecycle Messaging:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use your contact details to send critical updates via Push Notifications, WhatsApp, or SMS regarding:</span>
                                    <ul>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Booking confirmations and worker arrivals.</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Safety alerts or weather-related delays.</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Limited-time promotional offers tailored to your past service history.</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>You can opt out of all promotional or marketing messages at any time via the app settings or by following the unsubscribe instructions in the message. Critical service notifications (e.g., booking confirmations, safety alerts) cannot be opted out of.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>E. Continuous Platform Evolution</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Heatmapping:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We analyze aggregated, anonymized location data to see which neighborhoods have the highest demand for cooks or plumbers. This helps us recruit more workers in those areas to reduce your wait times.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Bug Detection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We collect technical "Crash Logs" to identify if the app is lagging on specific phones, allowing our developers to fix issues before they affect your booking experience.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Data Sharing: Who Sees Your Information?</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We maintain a strict "Need-to-Know" policy:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Assigned Worker:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once a booking is confirmed, the worker receives your First Name, Phone Number, and GPS Location. They do not see your full booking history or saved payment methods.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Aggregators:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your credit/debit card or UPI details are processed via PCI-DSS compliant partners. Maidly never stores your CVV or full card numbers on our local servers.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Legal &amp; Regulatory Bodies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We may share data with law enforcement if we suspect fraudulent activity or if a safety incident occurs during a service visit.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly uses the following third-party services that may process your personal information on our behalf:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Payment gateways: Razorpay, Stripe (for secure payment tokenization).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Analytics: Firebase Analytics, Mixpanel (for app performance and usage patterns).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Crash reporting: Firebase Crashlytics, Sentry (for app stability).</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>These providers process data on our behalf and are contractually obligated to protect user information and use it only for service-related purposes. Your personal information may be processed and stored on servers located outside India, including servers operated by our third-party service providers. We ensure that such transfers comply with applicable data protection laws and that appropriate safeguards are in place.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Retention and Deletion</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Active Accounts:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We keep your data as long as your account is active to provide a seamless booking history.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Deactivation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you request account deletion, we "anonymize" your personal details within 30 days. We retain transaction and billing records for 7 years as required by Indian tax and audit regulations. All other personal data from deactivated accounts is anonymized within 30 days.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>User Rights</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>You have the right to access, correct, download, or delete your personal information. You may request these actions by contacting our support team. We may verify your identity before processing such requests.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Enhanced Security Measures</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Encryption:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All data transmitted between your device and our servers is encrypted using industry-standard encryption protocols (such as TLS). Sensitive data stored on our servers is protected using strong encryption standards.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Access Control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Only authorized employees of Maidly can access your contact details, and all access is logged.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Children’s Privacy</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>In a service-oriented app like yours, the Children’s Privacy section isn't just about protecting kids who might open the app; it’s about the legal reality that your services (cleaning, cooking, babysitting) happen around children. The Maidly app is not designed for children and is not classified as a “Designed for Families” application under Google Play policies.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>A. Strict Age-Gating</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Our platform is a "General Audience" service intended exclusively for users aged 18 and above. We do not knowingly collect, solicit, or maintain personal information from anyone under the age of 18.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}During registration, we use neutral age-screening to prevent minors from creating accounts.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Termination:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If we discover that a person under 18 has created an account or provided us with personal data, we will deactivate the account and delete all associated data from our active servers within 24 hours.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>B. Data Pertaining to Children in the Home</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We recognize that our service providers (maids, nannies, cooks) may work in households where children are present.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Minimization of Child Data:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We strictly instruct customers not to share sensitive personal information about their children in open text fields or in-app chats unless strictly necessary for a caregiving service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>No Profiling:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly never creates digital profiles of children. Any mention of a minor in a service request is treated as "transient data" used only to fulfill that specific booking and is not used for targeted advertising or behavioral tracking.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>C. Safety &amp; Reporting for Minors</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Because our services involve adults entering private homes, we maintain a zero-tolerance policy regarding the privacy and safety of minors:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Background Verification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Every service professional undergoes a rigorous multi-level background check specifically to ensure the safety of all household members, especially children.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Prohibited Content:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Our service providers are strictly prohibited from taking photos or videos inside a customer's home that include the image of a minor. Any violation of this results in immediate permanent banning from the platform and potential legal action.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>D. Parental Rights</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you are a parent or guardian and believe that your child has inadvertently provided us with personal information, or if a service provider has improperly handled information regarding your child, please contact our Privacy Officer immediately at support@redqubes.com.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You have the right to review, delete, and refuse further collection of any information related to your minor child.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>We will cooperate fully with parents to ensure that any digital footprint left by a minor is erased permanently.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Updates to this Policy</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We may update this policy to reflect changes in the law. We will notify you via an in-app "What’s New" pop-up or email if any significant changes are made to how we handle your data.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Contact Us</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We believe in open communication. If you have questions about this Privacy Policy, your data rights, or how we handle your home’s security, please use the specific channels below to ensure your inquiry reaches the right department.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For questions regarding how we use your data, requests for data access, or updates to your personal information:</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <strong>Response Time:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}We aim to respond to all privacy-related inquiries within 24–48 hours.</span>
                            </p>
                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerPrivacyPolicy